/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CampaignPromoBarModuleRenderer, {
  useShouldShowCampaignPromoBarModule,
} from 'bundles/campaigns/module-renderers/CampaignPromoBarModuleRenderer';
import PageBannerModule from 'bundles/unified-description-page-common/components/modules/page-banner/PageBannerModule';
import Markdown from 'bundles/unified-description-page-common/components/shared/Markdown';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { SelfServeConfigPageBannerModuleFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type Props = {
  config?: SelfServeConfigPageBannerModuleFragment;
  pageData?: ConsumerCoursePageFieldsFragment | ConsumerSpecializationPageFieldsFragment;
};

const styles = {
  container: css`
    overflow: hidden;
    position: relative;
    z-index: 1;
  `,
};

const PageBannerModuleRenderer = ({ config }: Props) => {
  if (useShouldShowCampaignPromoBarModule()) {
    return (
      <div css={styles.container}>
        <CampaignPromoBarModuleRenderer />
      </div>
    );
  }

  /**
   * While this promotion is no longer active, we want to keep it for likely 
   * future iterations.
   *
   * If and when the Campaign system can be used to support Google, we can fully remove this.

  import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
  import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
  import GooglePromotionBanner from 'bundles/unified-description-page-common/components/shared/GooglePromotionBanner';
  import { GOOGLE_COURSERA_XDP_PROMOTION_SLUGS } from 'bundles/unified-description-page-common/constants/googleCourseraXdpPromotionSlugs';
  ...

  const { productSlug } = usePageInfo();

  ...
  if (
    GOOGLE_COURSERA_XDP_PROMOTION_SLUGS.includes(productSlug ?? '') &&
    GrowthDiscoveryExperiments.get('experimentName')
  ) {
    return <GooglePromotionBanner />;
  }
  */

  if (config?.message == null) {
    return null;
  }

  return <PageBannerModule message={<Markdown source={config.message} />} />;
};

export default PageBannerModuleRenderer;
